import * as React from "react";
import classnames from "classnames";
import { SelectionBoxRadio } from "@grandvisionhq/common";
import { TileLayout } from "../../../../../TileLayout/modules/EcommContent/components/TileLayout/TileLayout.js";
import { PriceLabel } from "../../../../components/modules/EcommContent/components/OfferingsList/components/PriceLabel.js";
/* empty css                   */
const OfferingsList = ({
  className,
  isCentAmount,
  offeringItems,
  selectedValue,
  onChange
}) => {
  return /* @__PURE__ */ React.createElement("fieldset", { className: classnames("offerings-list", className), "data-t": "offerings-list" }, offeringItems.map(
    ({ title, subTitle, originalPriceInformation, discountedPriceInformation, sku, icon }) => {
      return /* @__PURE__ */ React.createElement(
        SelectionBoxRadio,
        {
          key: title,
          name: "offerings",
          value: sku,
          checked: selectedValue === sku,
          onChange: () => sku && onChange(sku)
        },
        /* @__PURE__ */ React.createElement(TileLayout, { title, subtitle: subTitle, iconName: icon }, /* @__PURE__ */ React.createElement(
          PriceLabel,
          {
            isCentAmount,
            originalPriceInformation,
            discountedPriceInformation
          }
        ))
      );
    }
  ));
};
export {
  OfferingsList
};
//# sourceMappingURL=OfferingsList.js.map
